<script setup lang="ts">
/**
 * The feratel mark, beside the heading of the feratel agents' shelf (`catalogLogos`), in the
 * colour of the text around it. Decorative without a `label`.
 */
const props = defineProps<{ label?: string }>();
</script>

<template>
  <svg
    viewBox="0 0 319 189"
    :role="props.label ? 'img' : undefined"
    :aria-label="props.label"
    :aria-hidden="props.label ? undefined : 'true'"
    data-logo
  >
    <path
      d="M318.946 180.907C266.202 185.969 213.215 188.373 160.206 188.109C106.75 188.359 53.3173 185.98 0.118512 180.979L0.0107664 134.759H277.742L0 88.8679V7.5064C48.54 2.89773 105.472 0.00702948 160.109 0.00702948C213.157 -0.151319 266.176 2.36569 318.946 7.54755V83.6728H39.6313L319 129.965L318.946 180.907Z"
      fill="currentColor"
    />
  </svg>
</template>
